<template>
  <v-container class="pa-0">
    <v-row no-gutters v-for="row in rows" :key="row.id">
      <v-col
        v-for="item in row.items"
        :key="item.id"
        class="border header-text"
        :style="{
          backgroundColor: item.color || '',
        }"
      >
        <div class="ma-2">
          <template v-if="item.inputField">
            <v-text-field
              v-model="item.content"
              dense
              flat
              hide-details
              label="Enter value"
              solo
              :type="item.type || 'text'"
              @input="debouncedInputChange(item)"
            ></v-text-field>
          </template>
          <template v-else>
            {{ item.content }}
          </template>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import _ from 'lodash'
export default {
  props: {
    rows: Array
  },
  created () {
    this.debouncedInputChange = _.debounce(this.onInputChange, 500)
  },
  methods: {
    onInputChange (item) {
      this.$emit('editRow', item)
    }
  }
}
</script>
